<template>
  <div class="map-wrapper">
    <vendors-map
      v-if="validMapData.length"
      :map-data="validMapData"
      :t="t"
      :clusterPath="clusterPath"
    >
      <div class="vd-VendorsMap_SelectedVendor">
        <p class="h5 mb-2">{{ activeVendor.name }}</p>
        <div>
          <input :value="activeVendor.permalink" type="hidden" name="vendor" />
          <button type="submit" class="btn btn-sm btn-primary">
            {{ t.choose }}
          </button>
        </div>
      </div>
    </vendors-map>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VendorsMap from "./VendorsMap";

export default {
  name: "StoreVendorsMap",
  components: {
    VendorsMap,
  },
  props: {
    mapData: {
      type: Array,
      required: true,
    },
    clusterPath: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendorsIndex/activeVendor",
    }),
    validMapData() {
      return this.mapData.filter(entry => !isNaN(entry.lat) && !isNaN(entry.lng));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.map-wrapper {
  position: relative;
  height: 100%;
}

.vd-VendorsMap_SelectedVendor {
  background: $white;
  padding: $spacer-3;
  border-radius: $border-radius;
  pointer-events: auto;
  text-align: center;
  box-shadow: $box-shadow-sm;
  border: $width-border-thin solid $gray-300;
}
</style>
